import { render, staticRenderFns } from "./menuList.vue?vue&type=template&id=d5ae387e&"
import script from "./menuList.vue?vue&type=script&lang=js&"
export * from "./menuList.vue?vue&type=script&lang=js&"
import style0 from "./menuList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports